import { render, staticRenderFns } from "./TypeProportional.vue?vue&type=template&id=4074fe3e&scoped=true&"
import script from "./TypeProportional.vue?vue&type=script&lang=js&"
export * from "./TypeProportional.vue?vue&type=script&lang=js&"
import style0 from "./TypeProportional.vue?vue&type=style&index=0&id=4074fe3e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4074fe3e",
  null
  
)

export default component.exports